//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { TELEHEALTH_API_BASE_URL } from '../http/api-client.tokens';


export interface IClient {
    /**
     * Gets the active telehealth admin configuration.
     * @return Returns the active admin configuration.
     */
    getAdminConfig(): Observable<TelehealthAdminConfigResponse>;
    /**
     * Gets the active telehealth admin configuration as key-value-description pairs.
    Each configuration item includes its id, key, current value, and description.
     * @return Returns the active admin configuration as key-value-description pairs.
     */
    getAdminConfigList(): Observable<ConfigItemResponse[]>;
    /**
     * Creates or updates the active telehealth admin configuration.
     * @param body (optional) The admin configuration request.
     * @return Returns the saved admin configuration.
     */
    adminConfig(body?: TelehealthAdminConfigRequest | undefined): Observable<TelehealthAdminConfigResponse>;
    /**
     * Initializes a chat thread for the specified meeting.
    Creates a new ACS thread if one doesn't already exist.
    Ensures the current user is added as a thread member.
     * @param publicId The public meeting identifier.
     * @param body (optional) The chat initialization request containing the ACS user ID.
     * @return Returns the chat thread information.
     */
    initialize(publicId: string, body?: ChatInitializeRequest | undefined): Observable<ChatThreadDto>;
    /**
     * Retrieves chat message history for the specified meeting.
    Attempts to fetch from ACS first (for active meetings), falls back to SQL for historical access.
     * @param publicId The public meeting identifier.
     * @return Returns the chat message history.
     */
    messages(publicId: string): Observable<ChatMessageDto[]>;
    /**
     * Batch saves all chat messages from Azure Communication Services to SQL Server.
    This endpoint is typically called when a meeting completes or when the host triggers manual save.
    Operation is idempotent - safe to call multiple times.
     * @param publicId The public meeting identifier.
     * @return Chat history saved successfully (or was already saved).
     */
    saveHistory(publicId: string): Observable<void>;
    /**
     * Initiates a PSTN dial-out from an active telehealth meeting.
    The NP selects a phone number from the dial-pad UI; this endpoint places the call
    and merges the PSTN participant into the NP-patient session via ACS Call Automation.
    The call record is created with `Ringing` status. Status transitions
    (Connected / Ended / Failed) arrive asynchronously via the `/call-events` webhook.
     * @param publicId The public identifier of the active meeting.
     * @param body (optional) Dial-out parameters (target phone number, initiator ID).
     * @return No Content
     */
    dialOut(publicId: string, body?: DialOutRequest | undefined): Observable<void>;
    /**
     * Hangs up an active dial-out call for a specific meeting.
    Updates the `PhoneCall` record status to `Ended`.
     * @param publicId The public identifier of the meeting.
     * @param phoneCallId The internal `PhoneCallId` returned by the dial-out endpoint.
     * @return Call hung up successfully.
     */
    hangUp(publicId: string, phoneCallId: number): Observable<void>;
    /**
     * Returns a list of all active translators for the dial-out dropdown.
    Phone numbers are provided in E.164 format for direct dialling.
     * @param language (optional) Optional language filter (e.g. "Spanish"). Case-insensitive partial match.
     * @return Returns the list of translators.
     */
    translators(language?: string | undefined): Observable<TranslatorResponse[]>;
    /**
     * Returns a sorted list of all distinct languages present in the active translators.
    Use this to populate the language-filter dropdown in the dial-out UI.
     * @return Returns the list of languages.
     */
    languages(): Observable<string[]>;
    /**
     * Test endpoint to verify the webhook route is accessible and working.
    Returns 200 OK with diagnostic information about the request.
     * @return Webhook endpoint is accessible.
     */
    test(): Observable<void>;
    /**
     * Receives ACS Call Automation webhook events and updates the corresponding
    `PhoneCall` record status.

    This endpoint must be registered as the `CallbackUri` in your ACS
    `CreateCallOptions`. It must be publicly reachable by Azure.
    Configure in `appsettings.json → AzureCommunicationServices:PhoneCall:CallbackBaseUri`.
    Handled events:
    <list type="bullet"><item>`CallConnected` → Status: Connected</item><item>`CallDisconnected` → Status: Ended (with failure codes if abnormal)</item><item>`*Failed` → Status: Failed (with ACS ResultInformation code/subCode/message)</item><item>`*Cancelled` → Status: Cancelled</item></list>
     * @return Event processed (always return 200 — ACS retries on non-200).
     */
    callEvents(): Observable<void>;
    /**
     * @return OK
     */
    health(): Observable<void>;
    /**
     * @return OK
     */
    detailed(): Observable<HealthCheckResponse>;
    /**
     * Gets a room by its public identifier.
     * @param publicId The public-facing room identifier.
     * @return Returns the room.
     */
    rooms(publicId: string): Observable<RoomResponse>;
    /**
     * Returns a paginated list of active rooms.
     * @param page (optional) 1-based page number.
     * @param pageSize (optional) Number of items per page.
     * @return Returns the list of rooms.
     */
    rooms2(page?: number | undefined, pageSize?: number | undefined): Observable<RoomResponsePagedResult>;
    /**
     * Ends a room, updating its status and releasing provider resources.
     * @param publicId The public-facing room identifier.
     * @return Room ended successfully.
     */
    end(publicId: string): Observable<void>;
    /**
     * Adds a participant to an existing room.
     * @param publicId The public-facing room identifier.
     * @param body (optional) Participant details.
     * @return No Content
     */
    participantsPOST(publicId: string, body?: AddParticipantRequest | undefined): Observable<void>;
    /**
     * Removes a participant from a room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Participant removed.
     */
    participantsDELETE(publicId: string, participantId: number): Observable<void>;
    /**
     * Updates a participant's role in a room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @param body (optional) The new role.
     * @return Role updated.
     */
    role(publicId: string, participantId: number, body?: UpdateParticipantRoleRequest | undefined): Observable<void>;
    /**
     * Issues a short-lived join token for a participant so their client can connect to the room.
    The token must not be logged or persisted by the caller.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Returns join details including the access token.
     */
    joinToken(publicId: string, participantId: number): Observable<JoinRoomResponse>;
    /**
     * Ends the call for a single participant by marking them as left and removing from the room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Participant call ended successfully.
     */
    endCall(publicId: string, participantId: number): Observable<void>;
    /**
     * Gets a telehealth session by ID.
     * @param id The session identifier.
     * @return Returns the telehealth session.
     */
    sessions(id: number): Observable<TelehealthSessionResponse>;
    /**
     * Gets a paginated list of telehealth sessions.
     * @param statusId (optional) Represents the status of a telehealth session.
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param skip (optional) 
     * @return Returns the paged list of telehealth sessions.
     */
    sessions2(statusId?: TelehealthSessionStatus | undefined, page?: number | undefined, pageSize?: number | undefined, skip?: number | undefined): Observable<TelehealthSessionResponsePagedResult>;
    /**
     * Creates a telehealth meeting and returns a shareable join link.
    The ACS room is provisioned lazily on the first participant joining — not at creation time.
     * @param body (optional) Meeting scheduling details.
     * @return OK
     */
    meetings(body?: CreateMeetingLinkRequest | undefined): Observable<MeetingLinkResponse>;
    /**
     * Joins a meeting via its public ID.
    On the first call the ACS room is provisioned. Subsequent calls reuse the existing room.
    Authenticated users (with a userId) are given the Presenter (host) role.
    Guests (no userId) are given the Attendee role and must supply a display name.
    ACS identities are reused across meetings for the same user.
     * @param publicId The public meeting ID from the meeting link URL.
     * @param body (optional) Join parameters: userId (optional) and displayName (required for guests).
     * @return Returns join details with the access token.
     */
    join(publicId: string, body?: JoinMeetingRequest | undefined): Observable<JoinRoomResponse>;
    /**
     * Adds a participant to a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param body (optional) Participant details.
     * @return No Content
     */
    participantsPOST2(publicId: string, body?: AddParticipantRequest | undefined): Observable<void>;
    /**
     * Removes a participant from a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @return Participant removed.
     */
    participantsDELETE2(publicId: string, participantId: number): Observable<void>;
    /**
     * Updates a participant's role in a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @param body (optional) The new role.
     * @return Role updated.
     */
    role2(publicId: string, participantId: number, body?: UpdateParticipantRoleRequest | undefined): Observable<void>;
    /**
     * Issues a short-lived join token for a participant so their client can connect to the meeting.
    The token must not be logged or persisted by the caller.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @return Returns join details including the access token.
     */
    joinToken2(publicId: string, participantId: number): Observable<JoinRoomResponse>;
    /**
     * Generates a blob-specific SAS URL for uploading a meeting document.
    Upload permission is restricted to create/write for the target blob only.
     * @param meetingPublicId Public meeting identifier used to scope the storage folder.
     * @param body (optional) Upload request with target file name.
     * @return Returns upload SAS URL.
     */
    uploadUrl(meetingPublicId: string, body?: GenerateMeetingDocumentUploadUrlRequest | undefined): Observable<MeetingDocumentSasUrlResponse>;
    /**
     * Generates a blob-specific SAS URL for downloading a meeting document.
    Read permission is restricted to the target blob only.
     * @param meetingPublicId Public meeting identifier used to scope the storage folder.
     * @param fileName (optional) File name in the meeting folder.
     * @return Returns download SAS URL.
     */
    downloadUrl(meetingPublicId: string, fileName?: string | undefined): Observable<MeetingDocumentSasUrlResponse>;
}

@Injectable()
export class Client implements IClient {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    private http = inject(HttpClient);
    private baseUrl = inject<string>(TELEHEALTH_API_BASE_URL);

    /**
     * Gets the active telehealth admin configuration.
     * @return Returns the active admin configuration.
     */
    getAdminConfig(): Observable<TelehealthAdminConfigResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/get-admin-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TelehealthAdminConfigResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TelehealthAdminConfigResponse>;
        }));
    }

    protected processGetAdminConfig(response: HttpResponseBase): Observable<TelehealthAdminConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelehealthAdminConfigResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("No active configuration found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the active telehealth admin configuration as key-value-description pairs.
    Each configuration item includes its id, key, current value, and description.
     * @return Returns the active admin configuration as key-value-description pairs.
     */
    getAdminConfigList(): Observable<ConfigItemResponse[]> {
        let url_ = this.baseUrl + "/api/Telehealth/get-admin-config-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminConfigList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminConfigList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigItemResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigItemResponse[]>;
        }));
    }

    protected processGetAdminConfigList(response: HttpResponseBase): Observable<ConfigItemResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigItemResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("No active configuration found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates or updates the active telehealth admin configuration.
     * @param body (optional) The admin configuration request.
     * @return Returns the saved admin configuration.
     */
    adminConfig(body?: TelehealthAdminConfigRequest | undefined): Observable<TelehealthAdminConfigResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/admin-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TelehealthAdminConfigResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TelehealthAdminConfigResponse>;
        }));
    }

    protected processAdminConfig(response: HttpResponseBase): Observable<TelehealthAdminConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelehealthAdminConfigResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request data.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initializes a chat thread for the specified meeting.
    Creates a new ACS thread if one doesn't already exist.
    Ensures the current user is added as a thread member.
     * @param publicId The public meeting identifier.
     * @param body (optional) The chat initialization request containing the ACS user ID.
     * @return Returns the chat thread information.
     */
    initialize(publicId: string, body?: ChatInitializeRequest | undefined): Observable<ChatThreadDto> {
        let url_ = this.baseUrl + "/api/telehealth/meetings/{publicId}/chat/initialize";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitialize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitialize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatThreadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatThreadDto>;
        }));
    }

    protected processInitialize(response: HttpResponseBase): Observable<ChatThreadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatThreadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Chat is disabled for the meeting configuration.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves chat message history for the specified meeting.
    Attempts to fetch from ACS first (for active meetings), falls back to SQL for historical access.
     * @param publicId The public meeting identifier.
     * @return Returns the chat message history.
     */
    messages(publicId: string): Observable<ChatMessageDto[]> {
        let url_ = this.baseUrl + "/api/telehealth/meetings/{publicId}/chat/messages";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatMessageDto[]>;
        }));
    }

    protected processMessages(response: HttpResponseBase): Observable<ChatMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatMessageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Chat is disabled for the meeting configuration.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Batch saves all chat messages from Azure Communication Services to SQL Server.
    This endpoint is typically called when a meeting completes or when the host triggers manual save.
    Operation is idempotent - safe to call multiple times.
     * @param publicId The public meeting identifier.
     * @return Chat history saved successfully (or was already saved).
     */
    saveHistory(publicId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/telehealth/meetings/{publicId}/chat/save-history";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found or chat not initialized.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Chat is disabled for the meeting configuration.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiates a PSTN dial-out from an active telehealth meeting.
    The NP selects a phone number from the dial-pad UI; this endpoint places the call
    and merges the PSTN participant into the NP-patient session via ACS Call Automation.
    The call record is created with `Ringing` status. Status transitions
    (Connected / Ended / Failed) arrive asynchronously via the `/call-events` webhook.
     * @param publicId The public identifier of the active meeting.
     * @param body (optional) Dial-out parameters (target phone number, initiator ID).
     * @return No Content
     */
    dialOut(publicId: string, body?: DialOutRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/telehealth/meetings/{publicId}/dial-out";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDialOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDialOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDialOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            // 201 Created is a success status - return success, not exception
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request (e.g., bad phone number format).", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hangs up an active dial-out call for a specific meeting.
    Updates the `PhoneCall` record status to `Ended`.
     * @param publicId The public identifier of the meeting.
     * @param phoneCallId The internal `PhoneCallId` returned by the dial-out endpoint.
     * @return Call hung up successfully.
     */
    hangUp(publicId: string, phoneCallId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/telehealth/meetings/{publicId}/phone-calls/{phoneCallId}/hang-up";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (phoneCallId === undefined || phoneCallId === null)
            throw new globalThis.Error("The parameter 'phoneCallId' must be defined.");
        url_ = url_.replace("{phoneCallId}", encodeURIComponent("" + phoneCallId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHangUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHangUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHangUp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting or phone call not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of all active translators for the dial-out dropdown.
    Phone numbers are provided in E.164 format for direct dialling.
     * @param language (optional) Optional language filter (e.g. "Spanish"). Case-insensitive partial match.
     * @return Returns the list of translators.
     */
    translators(language?: string | undefined): Observable<TranslatorResponse[]> {
        let url_ = this.baseUrl + "/api/telehealth/translators?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TranslatorResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TranslatorResponse[]>;
        }));
    }

    protected processTranslators(response: HttpResponseBase): Observable<TranslatorResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslatorResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a sorted list of all distinct languages present in the active translators.
    Use this to populate the language-filter dropdown in the dial-out UI.
     * @return Returns the list of languages.
     */
    languages(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/telehealth/translators/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processLanguages(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test endpoint to verify the webhook route is accessible and working.
    Returns 200 OK with diagnostic information about the request.
     * @return Webhook endpoint is accessible.
     */
    test(): Observable<void> {
        let url_ = this.baseUrl + "/api/telehealth/call-events/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Receives ACS Call Automation webhook events and updates the corresponding
    `PhoneCall` record status.

    This endpoint must be registered as the `CallbackUri` in your ACS
    `CreateCallOptions`. It must be publicly reachable by Azure.
    Configure in `appsettings.json → AzureCommunicationServices:PhoneCall:CallbackBaseUri`.
    Handled events:
    <list type="bullet"><item>`CallConnected` → Status: Connected</item><item>`CallDisconnected` → Status: Ended (with failure codes if abnormal)</item><item>`*Failed` → Status: Failed (with ACS ResultInformation code/subCode/message)</item><item>`*Cancelled` → Status: Cancelled</item></list>
     * @return Event processed (always return 200 — ACS retries on non-200).
     */
    callEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/telehealth/call-events";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Service Unavailable", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    detailed(): Observable<HealthCheckResponse> {
        let url_ = this.baseUrl + "/health/detailed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCheckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCheckResponse>;
        }));
    }

    protected processDetailed(response: HttpResponseBase): Observable<HealthCheckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = HealthCheckResponse.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a room by its public identifier.
     * @param publicId The public-facing room identifier.
     * @return Returns the room.
     */
    rooms(publicId: string): Observable<RoomResponse> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomResponse>;
        }));
    }

    protected processRooms(response: HttpResponseBase): Observable<RoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a paginated list of active rooms.
     * @param page (optional) 1-based page number.
     * @param pageSize (optional) Number of items per page.
     * @return Returns the list of rooms.
     */
    rooms2(page?: number | undefined, pageSize?: number | undefined): Observable<RoomResponsePagedResult> {
        let url_ = this.baseUrl + "/api/Rooms?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRooms2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRooms2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomResponsePagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomResponsePagedResult>;
        }));
    }

    protected processRooms2(response: HttpResponseBase): Observable<RoomResponsePagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomResponsePagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ends a room, updating its status and releasing provider resources.
     * @param publicId The public-facing room identifier.
     * @return Room ended successfully.
     */
    end(publicId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/end";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a participant to an existing room.
     * @param publicId The public-facing room identifier.
     * @param body (optional) Participant details.
     * @return No Content
     */
    participantsPOST(publicId: string, body?: AddParticipantRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/participants";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            // 201 Created is a success status - return success, not exception
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes a participant from a room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Participant removed.
     */
    participantsDELETE(publicId: string, participantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/participants/{participantId}";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a participant's role in a room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @param body (optional) The new role.
     * @return Role updated.
     */
    role(publicId: string, participantId: number, body?: UpdateParticipantRoleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/participants/{participantId}/role";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Issues a short-lived join token for a participant so their client can connect to the room.
    The token must not be logged or persisted by the caller.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Returns join details including the access token.
     */
    joinToken(publicId: string, participantId: number): Observable<JoinRoomResponse> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/participants/{participantId}/join-token";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJoinToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoinToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinRoomResponse>;
        }));
    }

    protected processJoinToken(response: HttpResponseBase): Observable<JoinRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JoinRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ends the call for a single participant by marking them as left and removing from the room.
     * @param publicId The public-facing room identifier.
     * @param participantId The internal participant ID.
     * @return Participant call ended successfully.
     */
    endCall(publicId: string, participantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Rooms/{publicId}/participants/{participantId}/end-call";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndCall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndCall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEndCall(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Room or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a telehealth session by ID.
     * @param id The session identifier.
     * @return Returns the telehealth session.
     */
    sessions(id: number): Observable<TelehealthSessionResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/sessions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TelehealthSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TelehealthSessionResponse>;
        }));
    }

    protected processSessions(response: HttpResponseBase): Observable<TelehealthSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelehealthSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("If the session is not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a paginated list of telehealth sessions.
     * @param statusId (optional) Represents the status of a telehealth session.
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param skip (optional) 
     * @return Returns the paged list of telehealth sessions.
     */
    sessions2(statusId?: TelehealthSessionStatus | undefined, page?: number | undefined, pageSize?: number | undefined, skip?: number | undefined): Observable<TelehealthSessionResponsePagedResult> {
        let url_ = this.baseUrl + "/api/Telehealth/sessions?";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSessions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSessions2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TelehealthSessionResponsePagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TelehealthSessionResponsePagedResult>;
        }));
    }

    protected processSessions2(response: HttpResponseBase): Observable<TelehealthSessionResponsePagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TelehealthSessionResponsePagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a telehealth meeting and returns a shareable join link.
    The ACS room is provisioned lazily on the first participant joining — not at creation time.
     * @param body (optional) Meeting scheduling details.
     * @return OK
     */
    meetings(body?: CreateMeetingLinkRequest | undefined): Observable<MeetingLinkResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingLinkResponse>;
        }));
    }

    protected processMeetings(response: HttpResponseBase): Observable<MeetingLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Meeting created.", status, _responseText, _headers);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Joins a meeting via its public ID.
    On the first call the ACS room is provisioned. Subsequent calls reuse the existing room.
    Authenticated users (with a userId) are given the Presenter (host) role.
    Guests (no userId) are given the Attendee role and must supply a display name.
    ACS identities are reused across meetings for the same user.
     * @param publicId The public meeting ID from the meeting link URL.
     * @param body (optional) Join parameters: userId (optional) and displayName (required for guests).
     * @return Returns join details with the access token.
     */
    join(publicId: string, body?: JoinMeetingRequest | undefined): Observable<JoinRoomResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{publicId}/join";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinRoomResponse>;
        }));
    }

    protected processJoin(response: HttpResponseBase): Observable<JoinRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JoinRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request (e.g. missing display name for guest).", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a participant to a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param body (optional) Participant details.
     * @return No Content
     */
    participantsPOST2(publicId: string, body?: AddParticipantRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{publicId}/participants";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantsPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            // 201 Created is a success status - return success, not exception
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes a participant from a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @return Participant removed.
     */
    participantsDELETE2(publicId: string, participantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{publicId}/participants/{participantId}";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParticipantsDELETE2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantsDELETE2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantsDELETE2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a participant's role in a meeting.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @param body (optional) The new role.
     * @return Role updated.
     */
    role2(publicId: string, participantId: number, body?: UpdateParticipantRoleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{publicId}/participants/{participantId}/role";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRole2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRole2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRole2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Issues a short-lived join token for a participant so their client can connect to the meeting.
    The token must not be logged or persisted by the caller.
     * @param publicId The public-facing meeting identifier.
     * @param participantId The internal participant ID.
     * @return Returns join details including the access token.
     */
    joinToken2(publicId: string, participantId: number): Observable<JoinRoomResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{publicId}/participants/{participantId}/join-token";
        if (publicId === undefined || publicId === null)
            throw new globalThis.Error("The parameter 'publicId' must be defined.");
        url_ = url_.replace("{publicId}", encodeURIComponent("" + publicId));
        if (participantId === undefined || participantId === null)
            throw new globalThis.Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJoinToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoinToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinRoomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinRoomResponse>;
        }));
    }

    protected processJoinToken2(response: HttpResponseBase): Observable<JoinRoomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JoinRoomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Meeting or participant not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a blob-specific SAS URL for uploading a meeting document.
    Upload permission is restricted to create/write for the target blob only.
     * @param meetingPublicId Public meeting identifier used to scope the storage folder.
     * @param body (optional) Upload request with target file name.
     * @return Returns upload SAS URL.
     */
    uploadUrl(meetingPublicId: string, body?: GenerateMeetingDocumentUploadUrlRequest | undefined): Observable<MeetingDocumentSasUrlResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{meetingPublicId}/documents/upload-url";
        if (meetingPublicId === undefined || meetingPublicId === null)
            throw new globalThis.Error("The parameter 'meetingPublicId' must be defined.");
        url_ = url_.replace("{meetingPublicId}", encodeURIComponent("" + meetingPublicId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingDocumentSasUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingDocumentSasUrlResponse>;
        }));
    }

    protected processUploadUrl(response: HttpResponseBase): Observable<MeetingDocumentSasUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingDocumentSasUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid meeting ID or file extension.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a blob-specific SAS URL for downloading a meeting document.
    Read permission is restricted to the target blob only.
     * @param meetingPublicId Public meeting identifier used to scope the storage folder.
     * @param fileName (optional) File name in the meeting folder.
     * @return Returns download SAS URL.
     */
    downloadUrl(meetingPublicId: string, fileName?: string | undefined): Observable<MeetingDocumentSasUrlResponse> {
        let url_ = this.baseUrl + "/api/Telehealth/meetings/{meetingPublicId}/documents/download-url?";
        if (meetingPublicId === undefined || meetingPublicId === null)
            throw new globalThis.Error("The parameter 'meetingPublicId' must be defined.");
        url_ = url_.replace("{meetingPublicId}", encodeURIComponent("" + meetingPublicId));
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingDocumentSasUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingDocumentSasUrlResponse>;
        }));
    }

    protected processDownloadUrl(response: HttpResponseBase): Observable<MeetingDocumentSasUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingDocumentSasUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Invalid meeting ID or file name.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("File not found in this meeting folder.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Represents the ACS room role of a meeting participant. */
export enum AcsRoomRole {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class AddParticipantRequest implements IAddParticipantRequest {
    userId?: number | undefined;
    participantType!: ParticipantType;
    role!: AcsRoomRole;
    guestDisplayName?: string | undefined;
    guestEmail?: string | undefined;
    guestPhone?: string | undefined;
    isExternal?: boolean;

    constructor(data?: IAddParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.participantType = _data["participantType"];
            this.role = _data["role"];
            this.guestDisplayName = _data["guestDisplayName"];
            this.guestEmail = _data["guestEmail"];
            this.guestPhone = _data["guestPhone"];
            this.isExternal = _data["isExternal"];
        }
    }

    static fromJS(data: any): AddParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["participantType"] = this.participantType;
        data["role"] = this.role;
        data["guestDisplayName"] = this.guestDisplayName;
        data["guestEmail"] = this.guestEmail;
        data["guestPhone"] = this.guestPhone;
        data["isExternal"] = this.isExternal;
        return data;
    }
}

export interface IAddParticipantRequest {
    userId?: number | undefined;
    participantType: ParticipantType;
    role: AcsRoomRole;
    guestDisplayName?: string | undefined;
    guestEmail?: string | undefined;
    guestPhone?: string | undefined;
    isExternal?: boolean;
}

export class ChatInitializeRequest implements IChatInitializeRequest {
    currentUserAcsId?: string | undefined;

    constructor(data?: IChatInitializeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentUserAcsId = _data["currentUserAcsId"];
        }
    }

    static fromJS(data: any): ChatInitializeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatInitializeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUserAcsId"] = this.currentUserAcsId;
        return data;
    }
}

export interface IChatInitializeRequest {
    currentUserAcsId?: string | undefined;
}

export class ChatMessageDto implements IChatMessageDto {
    messageId?: string | undefined;
    senderDisplayName?: string | undefined;
    content?: string | undefined;
    sentAtUtc?: string;
    sequenceId?: number | undefined;
    isOwnMessage?: boolean;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.senderDisplayName = _data["senderDisplayName"];
            this.content = _data["content"];
            this.sentAtUtc = _data["sentAtUtc"];
            this.sequenceId = _data["sequenceId"];
            this.isOwnMessage = _data["isOwnMessage"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["senderDisplayName"] = this.senderDisplayName;
        data["content"] = this.content;
        data["sentAtUtc"] = this.sentAtUtc;
        data["sequenceId"] = this.sequenceId;
        data["isOwnMessage"] = this.isOwnMessage;
        return data;
    }
}

export interface IChatMessageDto {
    messageId?: string | undefined;
    senderDisplayName?: string | undefined;
    content?: string | undefined;
    sentAtUtc?: string;
    sequenceId?: number | undefined;
    isOwnMessage?: boolean;
}

export class ChatThreadDto implements IChatThreadDto {
    acsThreadId?: string | undefined;
    meetingId?: number;
    title?: string | undefined;
    createdAtUtc?: string;
    accessToken?: string | undefined;
    accessTokenExpiry?: string | undefined;

    constructor(data?: IChatThreadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acsThreadId = _data["acsThreadId"];
            this.meetingId = _data["meetingId"];
            this.title = _data["title"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.accessToken = _data["accessToken"];
            this.accessTokenExpiry = _data["accessTokenExpiry"];
        }
    }

    static fromJS(data: any): ChatThreadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatThreadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acsThreadId"] = this.acsThreadId;
        data["meetingId"] = this.meetingId;
        data["title"] = this.title;
        data["createdAtUtc"] = this.createdAtUtc;
        data["accessToken"] = this.accessToken;
        data["accessTokenExpiry"] = this.accessTokenExpiry;
        return data;
    }
}

export interface IChatThreadDto {
    acsThreadId?: string | undefined;
    meetingId?: number;
    title?: string | undefined;
    createdAtUtc?: string;
    accessToken?: string | undefined;
    accessTokenExpiry?: string | undefined;
}

export class ConfigItemResponse implements IConfigItemResponse {
    id?: number;
    key?: string | undefined;
    value?: any | undefined;
    description?: string | undefined;

    constructor(data?: IConfigItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ConfigItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IConfigItemResponse {
    id?: number;
    key?: string | undefined;
    value?: any | undefined;
    description?: string | undefined;
}

export class CreateMeetingLinkRequest implements ICreateMeetingLinkRequest {
    title!: string;
    scheduledStartUtc!: string;
    scheduledEndUtc!: string;
    externalAppointmentId?: number | undefined;
    maxParticipants?: number | undefined;
    createdByUserManagementId?: string | undefined;

    constructor(data?: ICreateMeetingLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.scheduledStartUtc = _data["scheduledStartUtc"];
            this.scheduledEndUtc = _data["scheduledEndUtc"];
            this.externalAppointmentId = _data["externalAppointmentId"];
            this.maxParticipants = _data["maxParticipants"];
            this.createdByUserManagementId = _data["createdByUserManagementId"];
        }
    }

    static fromJS(data: any): CreateMeetingLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeetingLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["scheduledStartUtc"] = this.scheduledStartUtc;
        data["scheduledEndUtc"] = this.scheduledEndUtc;
        data["externalAppointmentId"] = this.externalAppointmentId;
        data["maxParticipants"] = this.maxParticipants;
        data["createdByUserManagementId"] = this.createdByUserManagementId;
        return data;
    }
}

export interface ICreateMeetingLinkRequest {
    title: string;
    scheduledStartUtc: string;
    scheduledEndUtc: string;
    externalAppointmentId?: number | undefined;
    maxParticipants?: number | undefined;
    createdByUserManagementId?: string | undefined;
}

export class DialOutRequest implements IDialOutRequest {
    translatorId?: number | undefined;
    targetPhoneNumber?: string | undefined;
    initiatedByUserManagementId?: string | undefined;

    constructor(data?: IDialOutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translatorId = _data["translatorId"];
            this.targetPhoneNumber = _data["targetPhoneNumber"];
            this.initiatedByUserManagementId = _data["initiatedByUserManagementId"];
        }
    }

    static fromJS(data: any): DialOutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DialOutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatorId"] = this.translatorId;
        data["targetPhoneNumber"] = this.targetPhoneNumber;
        data["initiatedByUserManagementId"] = this.initiatedByUserManagementId;
        return data;
    }
}

export interface IDialOutRequest {
    translatorId?: number | undefined;
    targetPhoneNumber?: string | undefined;
    initiatedByUserManagementId?: string | undefined;
}

export class DialOutResponse implements IDialOutResponse {
    phoneCallId?: number;
    translatorId?: number | undefined;
    callConnectionId?: string | undefined;
    maskedTargetNumber?: string | undefined;
    status?: PhoneCallStatus;
    startedAtUtc?: string;

    constructor(data?: IDialOutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCallId = _data["phoneCallId"];
            this.translatorId = _data["translatorId"];
            this.callConnectionId = _data["callConnectionId"];
            this.maskedTargetNumber = _data["maskedTargetNumber"];
            this.status = _data["status"];
            this.startedAtUtc = _data["startedAtUtc"];
        }
    }

    static fromJS(data: any): DialOutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DialOutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCallId"] = this.phoneCallId;
        data["translatorId"] = this.translatorId;
        data["callConnectionId"] = this.callConnectionId;
        data["maskedTargetNumber"] = this.maskedTargetNumber;
        data["status"] = this.status;
        data["startedAtUtc"] = this.startedAtUtc;
        return data;
    }
}

export interface IDialOutResponse {
    phoneCallId?: number;
    translatorId?: number | undefined;
    callConnectionId?: string | undefined;
    maskedTargetNumber?: string | undefined;
    status?: PhoneCallStatus;
    startedAtUtc?: string;
}

export class GenerateMeetingDocumentUploadUrlRequest implements IGenerateMeetingDocumentUploadUrlRequest {
    fileName!: string;

    constructor(data?: IGenerateMeetingDocumentUploadUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): GenerateMeetingDocumentUploadUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateMeetingDocumentUploadUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IGenerateMeetingDocumentUploadUrlRequest {
    fileName: string;
}

export class HealthCheckResponse implements IHealthCheckResponse {
    status?: string | undefined;
    timestamp?: string;
    version?: string | undefined;
    environment?: string | undefined;
    details?: { [key: string]: string; } | undefined;

    constructor(data?: IHealthCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timestamp = _data["timestamp"];
            this.version = _data["version"];
            this.environment = _data["environment"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (this.details as any)![key] = _data["details"][key];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timestamp"] = this.timestamp;
        data["version"] = this.version;
        data["environment"] = this.environment;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (data["details"] as any)[key] = (this.details as any)[key];
            }
        }
        return data;
    }
}

export interface IHealthCheckResponse {
    status?: string | undefined;
    timestamp?: string;
    version?: string | undefined;
    environment?: string | undefined;
    details?: { [key: string]: string; } | undefined;
}

export class JoinMeetingRequest implements IJoinMeetingRequest {
    userId?: number | undefined;
    displayName?: string | undefined;

    constructor(data?: IJoinMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): JoinMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JoinMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IJoinMeetingRequest {
    userId?: number | undefined;
    displayName?: string | undefined;
}

export class JoinRoomResponse implements IJoinRoomResponse {
    publicRoomId?: string | undefined;
    providerRoomId?: string | undefined;
    providerName?: string | undefined;
    providerUserId?: string | undefined;
    accessToken?: string | undefined;
    acsEndpoint?: string | undefined;
    displayName?: string | undefined;
    role?: AcsRoomRole;

    constructor(data?: IJoinRoomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicRoomId = _data["publicRoomId"];
            this.providerRoomId = _data["providerRoomId"];
            this.providerName = _data["providerName"];
            this.providerUserId = _data["providerUserId"];
            this.accessToken = _data["accessToken"];
            this.acsEndpoint = _data["acsEndpoint"];
            this.displayName = _data["displayName"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): JoinRoomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JoinRoomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicRoomId"] = this.publicRoomId;
        data["providerRoomId"] = this.providerRoomId;
        data["providerName"] = this.providerName;
        data["providerUserId"] = this.providerUserId;
        data["accessToken"] = this.accessToken;
        data["acsEndpoint"] = this.acsEndpoint;
        data["displayName"] = this.displayName;
        data["role"] = this.role;
        return data;
    }
}

export interface IJoinRoomResponse {
    publicRoomId?: string | undefined;
    providerRoomId?: string | undefined;
    providerName?: string | undefined;
    providerUserId?: string | undefined;
    accessToken?: string | undefined;
    acsEndpoint?: string | undefined;
    displayName?: string | undefined;
    role?: AcsRoomRole;
}

export class MeetingDocumentSasUrlResponse implements IMeetingDocumentSasUrlResponse {
    meetingId?: string | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;
    sasUrl?: string | undefined;
    expiresOnUtc?: string;

    constructor(data?: IMeetingDocumentSasUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"];
            this.fileName = _data["fileName"];
            this.blobName = _data["blobName"];
            this.sasUrl = _data["sasUrl"];
            this.expiresOnUtc = _data["expiresOnUtc"];
        }
    }

    static fromJS(data: any): MeetingDocumentSasUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingDocumentSasUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId;
        data["fileName"] = this.fileName;
        data["blobName"] = this.blobName;
        data["sasUrl"] = this.sasUrl;
        data["expiresOnUtc"] = this.expiresOnUtc;
        return data;
    }
}

export interface IMeetingDocumentSasUrlResponse {
    meetingId?: string | undefined;
    fileName?: string | undefined;
    blobName?: string | undefined;
    sasUrl?: string | undefined;
    expiresOnUtc?: string;
}

export class MeetingLinkResponse implements IMeetingLinkResponse {
    meetingId?: number;
    publicId?: string | undefined;
    meetingUrl?: string | undefined;
    title?: string | undefined;
    scheduledStartUtc?: string;
    scheduledEndUtc?: string;
    externalAppointmentId?: number | undefined;
    status?: MeetingStatus;

    constructor(data?: IMeetingLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"];
            this.publicId = _data["publicId"];
            this.meetingUrl = _data["meetingUrl"];
            this.title = _data["title"];
            this.scheduledStartUtc = _data["scheduledStartUtc"];
            this.scheduledEndUtc = _data["scheduledEndUtc"];
            this.externalAppointmentId = _data["externalAppointmentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MeetingLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId;
        data["publicId"] = this.publicId;
        data["meetingUrl"] = this.meetingUrl;
        data["title"] = this.title;
        data["scheduledStartUtc"] = this.scheduledStartUtc;
        data["scheduledEndUtc"] = this.scheduledEndUtc;
        data["externalAppointmentId"] = this.externalAppointmentId;
        data["status"] = this.status;
        return data;
    }
}

export interface IMeetingLinkResponse {
    meetingId?: number;
    publicId?: string | undefined;
    meetingUrl?: string | undefined;
    title?: string | undefined;
    scheduledStartUtc?: string;
    scheduledEndUtc?: string;
    externalAppointmentId?: number | undefined;
    status?: MeetingStatus;
}

/** Represents the status of a telehealth meeting. */
export enum MeetingStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Represents the type of a meeting participant. */
export enum ParticipantType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

/** Represents the status of a phone call. */
export enum PhoneCallStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RoomParticipantResponse implements IRoomParticipantResponse {
    meetingParticipantId?: number;
    userId?: number | undefined;
    acsUserId?: string | undefined;
    participantType?: ParticipantType;
    role?: AcsRoomRole;
    guestDisplayName?: string | undefined;
    isExternal?: boolean;
    joinedAtUtc?: string | undefined;
    leftAtUtc?: string | undefined;

    constructor(data?: IRoomParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingParticipantId = _data["meetingParticipantId"];
            this.userId = _data["userId"];
            this.acsUserId = _data["acsUserId"];
            this.participantType = _data["participantType"];
            this.role = _data["role"];
            this.guestDisplayName = _data["guestDisplayName"];
            this.isExternal = _data["isExternal"];
            this.joinedAtUtc = _data["joinedAtUtc"];
            this.leftAtUtc = _data["leftAtUtc"];
        }
    }

    static fromJS(data: any): RoomParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoomParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingParticipantId"] = this.meetingParticipantId;
        data["userId"] = this.userId;
        data["acsUserId"] = this.acsUserId;
        data["participantType"] = this.participantType;
        data["role"] = this.role;
        data["guestDisplayName"] = this.guestDisplayName;
        data["isExternal"] = this.isExternal;
        data["joinedAtUtc"] = this.joinedAtUtc;
        data["leftAtUtc"] = this.leftAtUtc;
        return data;
    }
}

export interface IRoomParticipantResponse {
    meetingParticipantId?: number;
    userId?: number | undefined;
    acsUserId?: string | undefined;
    participantType?: ParticipantType;
    role?: AcsRoomRole;
    guestDisplayName?: string | undefined;
    isExternal?: boolean;
    joinedAtUtc?: string | undefined;
    leftAtUtc?: string | undefined;
}

export class RoomResponse implements IRoomResponse {
    meetingId?: number;
    publicId?: string | undefined;
    title?: string | undefined;
    providerRoomId?: string | undefined;
    providerName?: string | undefined;
    scheduledStartUtc?: string;
    scheduledEndUtc?: string;
    roomValidFrom?: string | undefined;
    roomValidUntil?: string | undefined;
    status?: MeetingStatus;
    maxParticipants?: number;
    joinLink?: string | undefined;
    externalAppointmentId?: number | undefined;
    participants?: RoomParticipantResponse[] | undefined;

    constructor(data?: IRoomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"];
            this.publicId = _data["publicId"];
            this.title = _data["title"];
            this.providerRoomId = _data["providerRoomId"];
            this.providerName = _data["providerName"];
            this.scheduledStartUtc = _data["scheduledStartUtc"];
            this.scheduledEndUtc = _data["scheduledEndUtc"];
            this.roomValidFrom = _data["roomValidFrom"];
            this.roomValidUntil = _data["roomValidUntil"];
            this.status = _data["status"];
            this.maxParticipants = _data["maxParticipants"];
            this.joinLink = _data["joinLink"];
            this.externalAppointmentId = _data["externalAppointmentId"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(RoomParticipantResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId;
        data["publicId"] = this.publicId;
        data["title"] = this.title;
        data["providerRoomId"] = this.providerRoomId;
        data["providerName"] = this.providerName;
        data["scheduledStartUtc"] = this.scheduledStartUtc;
        data["scheduledEndUtc"] = this.scheduledEndUtc;
        data["roomValidFrom"] = this.roomValidFrom;
        data["roomValidUntil"] = this.roomValidUntil;
        data["status"] = this.status;
        data["maxParticipants"] = this.maxParticipants;
        data["joinLink"] = this.joinLink;
        data["externalAppointmentId"] = this.externalAppointmentId;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoomResponse {
    meetingId?: number;
    publicId?: string | undefined;
    title?: string | undefined;
    providerRoomId?: string | undefined;
    providerName?: string | undefined;
    scheduledStartUtc?: string;
    scheduledEndUtc?: string;
    roomValidFrom?: string | undefined;
    roomValidUntil?: string | undefined;
    status?: MeetingStatus;
    maxParticipants?: number;
    joinLink?: string | undefined;
    externalAppointmentId?: number | undefined;
    participants?: RoomParticipantResponse[] | undefined;
}

export class RoomResponsePagedResult implements IRoomResponsePagedResult {
    items?: RoomResponse[] | undefined;
    readonly pageIndex?: number;
    readonly pageSize?: number;
    totalItems?: number;
    readonly totalPages?: number;
    readonly hasPreviousPage?: boolean;
    readonly hasNextPage?: boolean;

    constructor(data?: IRoomResponsePagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoomResponse.fromJS(item));
            }
            (this as any).pageIndex = _data["pageIndex"];
            (this as any).pageSize = _data["pageSize"];
            this.totalItems = _data["totalItems"];
            (this as any).totalPages = _data["totalPages"];
            (this as any).hasPreviousPage = _data["hasPreviousPage"];
            (this as any).hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): RoomResponsePagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new RoomResponsePagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IRoomResponsePagedResult {
    items?: RoomResponse[] | undefined;
    pageIndex?: number;
    pageSize?: number;
    totalItems?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TelehealthAdminConfigRequest implements ITelehealthAdminConfigRequest {
    isVideoEnabled?: boolean | undefined;
    isAudioEnabled?: boolean | undefined;
    isNoiseSuppressionEnabled?: boolean | undefined;
    isVirtualBackgroundEnabled?: boolean | undefined;
    isClosedCaptioningEnabled?: boolean | undefined;
    isVoiceTranslationEnabled?: boolean | undefined;
    isScreenShareEnabled?: boolean | undefined;
    isFileUploadEnabled?: boolean | undefined;
    isChatEnabled?: boolean | undefined;
    maxParticipants?: number | undefined;
    allowParticipantControls?: boolean | undefined;
    allowRemoveParticipant?: boolean | undefined;
    allowHostTransfer?: boolean | undefined;
    allowMuteAll?: boolean | undefined;
    allowEndMeetingForAll?: boolean | undefined;
    allowSendInvite?: boolean | undefined;
    isGuestLobbyEnabled?: boolean | undefined;
    requireProviderAdmission?: boolean | undefined;
    isPstnDialOutEnabled?: boolean | undefined;
    isRecordingEnabled?: boolean | undefined;
    isAIScribeEnabled?: boolean | undefined;
    isSoapNoteEnabled?: boolean | undefined;
    defaultTokenExpirationMinutes?: number | undefined;
    guestLinkExpirationMinutes?: number | undefined;
    earlyJoinWindowMinutes?: number | undefined;
    lateJoinWindowMinutes?: number | undefined;
    roomValidityBufferMinutesBefore?: number | undefined;
    roomValidityBufferMinutesAfter?: number | undefined;
    shortCodeFormat?: string | undefined;
    updatedByUserManagementId?: string | undefined;

    constructor(data?: ITelehealthAdminConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVideoEnabled = _data["isVideoEnabled"];
            this.isAudioEnabled = _data["isAudioEnabled"];
            this.isNoiseSuppressionEnabled = _data["isNoiseSuppressionEnabled"];
            this.isVirtualBackgroundEnabled = _data["isVirtualBackgroundEnabled"];
            this.isClosedCaptioningEnabled = _data["isClosedCaptioningEnabled"];
            this.isVoiceTranslationEnabled = _data["isVoiceTranslationEnabled"];
            this.isScreenShareEnabled = _data["isScreenShareEnabled"];
            this.isFileUploadEnabled = _data["isFileUploadEnabled"];
            this.isChatEnabled = _data["isChatEnabled"];
            this.maxParticipants = _data["maxParticipants"];
            this.allowParticipantControls = _data["allowParticipantControls"];
            this.allowRemoveParticipant = _data["allowRemoveParticipant"];
            this.allowHostTransfer = _data["allowHostTransfer"];
            this.allowMuteAll = _data["allowMuteAll"];
            this.allowEndMeetingForAll = _data["allowEndMeetingForAll"];
            this.allowSendInvite = _data["allowSendInvite"];
            this.isGuestLobbyEnabled = _data["isGuestLobbyEnabled"];
            this.requireProviderAdmission = _data["requireProviderAdmission"];
            this.isPstnDialOutEnabled = _data["isPstnDialOutEnabled"];
            this.isRecordingEnabled = _data["isRecordingEnabled"];
            this.isAIScribeEnabled = _data["isAIScribeEnabled"];
            this.isSoapNoteEnabled = _data["isSoapNoteEnabled"];
            this.defaultTokenExpirationMinutes = _data["defaultTokenExpirationMinutes"];
            this.guestLinkExpirationMinutes = _data["guestLinkExpirationMinutes"];
            this.earlyJoinWindowMinutes = _data["earlyJoinWindowMinutes"];
            this.lateJoinWindowMinutes = _data["lateJoinWindowMinutes"];
            this.roomValidityBufferMinutesBefore = _data["roomValidityBufferMinutesBefore"];
            this.roomValidityBufferMinutesAfter = _data["roomValidityBufferMinutesAfter"];
            this.shortCodeFormat = _data["shortCodeFormat"];
            this.updatedByUserManagementId = _data["updatedByUserManagementId"];
        }
    }

    static fromJS(data: any): TelehealthAdminConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TelehealthAdminConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVideoEnabled"] = this.isVideoEnabled;
        data["isAudioEnabled"] = this.isAudioEnabled;
        data["isNoiseSuppressionEnabled"] = this.isNoiseSuppressionEnabled;
        data["isVirtualBackgroundEnabled"] = this.isVirtualBackgroundEnabled;
        data["isClosedCaptioningEnabled"] = this.isClosedCaptioningEnabled;
        data["isVoiceTranslationEnabled"] = this.isVoiceTranslationEnabled;
        data["isScreenShareEnabled"] = this.isScreenShareEnabled;
        data["isFileUploadEnabled"] = this.isFileUploadEnabled;
        data["isChatEnabled"] = this.isChatEnabled;
        data["maxParticipants"] = this.maxParticipants;
        data["allowParticipantControls"] = this.allowParticipantControls;
        data["allowRemoveParticipant"] = this.allowRemoveParticipant;
        data["allowHostTransfer"] = this.allowHostTransfer;
        data["allowMuteAll"] = this.allowMuteAll;
        data["allowEndMeetingForAll"] = this.allowEndMeetingForAll;
        data["allowSendInvite"] = this.allowSendInvite;
        data["isGuestLobbyEnabled"] = this.isGuestLobbyEnabled;
        data["requireProviderAdmission"] = this.requireProviderAdmission;
        data["isPstnDialOutEnabled"] = this.isPstnDialOutEnabled;
        data["isRecordingEnabled"] = this.isRecordingEnabled;
        data["isAIScribeEnabled"] = this.isAIScribeEnabled;
        data["isSoapNoteEnabled"] = this.isSoapNoteEnabled;
        data["defaultTokenExpirationMinutes"] = this.defaultTokenExpirationMinutes;
        data["guestLinkExpirationMinutes"] = this.guestLinkExpirationMinutes;
        data["earlyJoinWindowMinutes"] = this.earlyJoinWindowMinutes;
        data["lateJoinWindowMinutes"] = this.lateJoinWindowMinutes;
        data["roomValidityBufferMinutesBefore"] = this.roomValidityBufferMinutesBefore;
        data["roomValidityBufferMinutesAfter"] = this.roomValidityBufferMinutesAfter;
        data["shortCodeFormat"] = this.shortCodeFormat;
        data["updatedByUserManagementId"] = this.updatedByUserManagementId;
        return data;
    }
}

export interface ITelehealthAdminConfigRequest {
    isVideoEnabled?: boolean | undefined;
    isAudioEnabled?: boolean | undefined;
    isNoiseSuppressionEnabled?: boolean | undefined;
    isVirtualBackgroundEnabled?: boolean | undefined;
    isClosedCaptioningEnabled?: boolean | undefined;
    isVoiceTranslationEnabled?: boolean | undefined;
    isScreenShareEnabled?: boolean | undefined;
    isFileUploadEnabled?: boolean | undefined;
    isChatEnabled?: boolean | undefined;
    maxParticipants?: number | undefined;
    allowParticipantControls?: boolean | undefined;
    allowRemoveParticipant?: boolean | undefined;
    allowHostTransfer?: boolean | undefined;
    allowMuteAll?: boolean | undefined;
    allowEndMeetingForAll?: boolean | undefined;
    allowSendInvite?: boolean | undefined;
    isGuestLobbyEnabled?: boolean | undefined;
    requireProviderAdmission?: boolean | undefined;
    isPstnDialOutEnabled?: boolean | undefined;
    isRecordingEnabled?: boolean | undefined;
    isAIScribeEnabled?: boolean | undefined;
    isSoapNoteEnabled?: boolean | undefined;
    defaultTokenExpirationMinutes?: number | undefined;
    guestLinkExpirationMinutes?: number | undefined;
    earlyJoinWindowMinutes?: number | undefined;
    lateJoinWindowMinutes?: number | undefined;
    roomValidityBufferMinutesBefore?: number | undefined;
    roomValidityBufferMinutesAfter?: number | undefined;
    shortCodeFormat?: string | undefined;
    updatedByUserManagementId?: string | undefined;
}

export class TelehealthAdminConfigResponse implements ITelehealthAdminConfigResponse {
    isVideoEnabled?: boolean;
    isAudioEnabled?: boolean;
    isNoiseSuppressionEnabled?: boolean;
    isVirtualBackgroundEnabled?: boolean;
    isClosedCaptioningEnabled?: boolean;
    isVoiceTranslationEnabled?: boolean;
    isScreenShareEnabled?: boolean;
    isFileUploadEnabled?: boolean;
    isChatEnabled?: boolean;
    maxParticipants?: number;
    allowParticipantControls?: boolean;
    allowRemoveParticipant?: boolean;
    allowHostTransfer?: boolean;
    allowMuteAll?: boolean;
    allowEndMeetingForAll?: boolean;
    allowSendInvite?: boolean;
    isGuestLobbyEnabled?: boolean;
    requireProviderAdmission?: boolean;
    isPstnDialOutEnabled?: boolean;
    isRecordingEnabled?: boolean;
    isAIScribeEnabled?: boolean;
    isSoapNoteEnabled?: boolean;
    defaultTokenExpirationMinutes?: number;
    guestLinkExpirationMinutes?: number;
    earlyJoinWindowMinutes?: number;
    lateJoinWindowMinutes?: number;
    roomValidityBufferMinutesBefore?: number;
    roomValidityBufferMinutesAfter?: number;
    shortCodeFormat?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITelehealthAdminConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVideoEnabled = _data["isVideoEnabled"];
            this.isAudioEnabled = _data["isAudioEnabled"];
            this.isNoiseSuppressionEnabled = _data["isNoiseSuppressionEnabled"];
            this.isVirtualBackgroundEnabled = _data["isVirtualBackgroundEnabled"];
            this.isClosedCaptioningEnabled = _data["isClosedCaptioningEnabled"];
            this.isVoiceTranslationEnabled = _data["isVoiceTranslationEnabled"];
            this.isScreenShareEnabled = _data["isScreenShareEnabled"];
            this.isFileUploadEnabled = _data["isFileUploadEnabled"];
            this.isChatEnabled = _data["isChatEnabled"];
            this.maxParticipants = _data["maxParticipants"];
            this.allowParticipantControls = _data["allowParticipantControls"];
            this.allowRemoveParticipant = _data["allowRemoveParticipant"];
            this.allowHostTransfer = _data["allowHostTransfer"];
            this.allowMuteAll = _data["allowMuteAll"];
            this.allowEndMeetingForAll = _data["allowEndMeetingForAll"];
            this.allowSendInvite = _data["allowSendInvite"];
            this.isGuestLobbyEnabled = _data["isGuestLobbyEnabled"];
            this.requireProviderAdmission = _data["requireProviderAdmission"];
            this.isPstnDialOutEnabled = _data["isPstnDialOutEnabled"];
            this.isRecordingEnabled = _data["isRecordingEnabled"];
            this.isAIScribeEnabled = _data["isAIScribeEnabled"];
            this.isSoapNoteEnabled = _data["isSoapNoteEnabled"];
            this.defaultTokenExpirationMinutes = _data["defaultTokenExpirationMinutes"];
            this.guestLinkExpirationMinutes = _data["guestLinkExpirationMinutes"];
            this.earlyJoinWindowMinutes = _data["earlyJoinWindowMinutes"];
            this.lateJoinWindowMinutes = _data["lateJoinWindowMinutes"];
            this.roomValidityBufferMinutesBefore = _data["roomValidityBufferMinutesBefore"];
            this.roomValidityBufferMinutesAfter = _data["roomValidityBufferMinutesAfter"];
            this.shortCodeFormat = _data["shortCodeFormat"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TelehealthAdminConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelehealthAdminConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVideoEnabled"] = this.isVideoEnabled;
        data["isAudioEnabled"] = this.isAudioEnabled;
        data["isNoiseSuppressionEnabled"] = this.isNoiseSuppressionEnabled;
        data["isVirtualBackgroundEnabled"] = this.isVirtualBackgroundEnabled;
        data["isClosedCaptioningEnabled"] = this.isClosedCaptioningEnabled;
        data["isVoiceTranslationEnabled"] = this.isVoiceTranslationEnabled;
        data["isScreenShareEnabled"] = this.isScreenShareEnabled;
        data["isFileUploadEnabled"] = this.isFileUploadEnabled;
        data["isChatEnabled"] = this.isChatEnabled;
        data["maxParticipants"] = this.maxParticipants;
        data["allowParticipantControls"] = this.allowParticipantControls;
        data["allowRemoveParticipant"] = this.allowRemoveParticipant;
        data["allowHostTransfer"] = this.allowHostTransfer;
        data["allowMuteAll"] = this.allowMuteAll;
        data["allowEndMeetingForAll"] = this.allowEndMeetingForAll;
        data["allowSendInvite"] = this.allowSendInvite;
        data["isGuestLobbyEnabled"] = this.isGuestLobbyEnabled;
        data["requireProviderAdmission"] = this.requireProviderAdmission;
        data["isPstnDialOutEnabled"] = this.isPstnDialOutEnabled;
        data["isRecordingEnabled"] = this.isRecordingEnabled;
        data["isAIScribeEnabled"] = this.isAIScribeEnabled;
        data["isSoapNoteEnabled"] = this.isSoapNoteEnabled;
        data["defaultTokenExpirationMinutes"] = this.defaultTokenExpirationMinutes;
        data["guestLinkExpirationMinutes"] = this.guestLinkExpirationMinutes;
        data["earlyJoinWindowMinutes"] = this.earlyJoinWindowMinutes;
        data["lateJoinWindowMinutes"] = this.lateJoinWindowMinutes;
        data["roomValidityBufferMinutesBefore"] = this.roomValidityBufferMinutesBefore;
        data["roomValidityBufferMinutesAfter"] = this.roomValidityBufferMinutesAfter;
        data["shortCodeFormat"] = this.shortCodeFormat;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITelehealthAdminConfigResponse {
    isVideoEnabled?: boolean;
    isAudioEnabled?: boolean;
    isNoiseSuppressionEnabled?: boolean;
    isVirtualBackgroundEnabled?: boolean;
    isClosedCaptioningEnabled?: boolean;
    isVoiceTranslationEnabled?: boolean;
    isScreenShareEnabled?: boolean;
    isFileUploadEnabled?: boolean;
    isChatEnabled?: boolean;
    maxParticipants?: number;
    allowParticipantControls?: boolean;
    allowRemoveParticipant?: boolean;
    allowHostTransfer?: boolean;
    allowMuteAll?: boolean;
    allowEndMeetingForAll?: boolean;
    allowSendInvite?: boolean;
    isGuestLobbyEnabled?: boolean;
    requireProviderAdmission?: boolean;
    isPstnDialOutEnabled?: boolean;
    isRecordingEnabled?: boolean;
    isAIScribeEnabled?: boolean;
    isSoapNoteEnabled?: boolean;
    defaultTokenExpirationMinutes?: number;
    guestLinkExpirationMinutes?: number;
    earlyJoinWindowMinutes?: number;
    lateJoinWindowMinutes?: number;
    roomValidityBufferMinutesBefore?: number;
    roomValidityBufferMinutesAfter?: number;
    shortCodeFormat?: string | undefined;
    isActive?: boolean;
}

export class TelehealthSessionResponse implements ITelehealthSessionResponse {
    telehealthSessionId?: number;
    sessionName?: string | undefined;
    statusId?: TelehealthSessionStatus;
    isActive?: boolean;

    constructor(data?: ITelehealthSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telehealthSessionId = _data["telehealthSessionId"];
            this.sessionName = _data["sessionName"];
            this.statusId = _data["statusId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TelehealthSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelehealthSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telehealthSessionId"] = this.telehealthSessionId;
        data["sessionName"] = this.sessionName;
        data["statusId"] = this.statusId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITelehealthSessionResponse {
    telehealthSessionId?: number;
    sessionName?: string | undefined;
    statusId?: TelehealthSessionStatus;
    isActive?: boolean;
}

export class TelehealthSessionResponsePagedResult implements ITelehealthSessionResponsePagedResult {
    items?: TelehealthSessionResponse[] | undefined;
    readonly pageIndex?: number;
    readonly pageSize?: number;
    totalItems?: number;
    readonly totalPages?: number;
    readonly hasPreviousPage?: boolean;
    readonly hasNextPage?: boolean;

    constructor(data?: ITelehealthSessionResponsePagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TelehealthSessionResponse.fromJS(item));
            }
            (this as any).pageIndex = _data["pageIndex"];
            (this as any).pageSize = _data["pageSize"];
            this.totalItems = _data["totalItems"];
            (this as any).totalPages = _data["totalPages"];
            (this as any).hasPreviousPage = _data["hasPreviousPage"];
            (this as any).hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): TelehealthSessionResponsePagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new TelehealthSessionResponsePagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface ITelehealthSessionResponsePagedResult {
    items?: TelehealthSessionResponse[] | undefined;
    pageIndex?: number;
    pageSize?: number;
    totalItems?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

/** Represents the status of a telehealth session. */
export enum TelehealthSessionStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TranslatorResponse implements ITranslatorResponse {
    translatorId?: number;
    language?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ITranslatorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translatorId = _data["translatorId"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): TranslatorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatorId"] = this.translatorId;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ITranslatorResponse {
    translatorId?: number;
    language?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UpdateParticipantRoleRequest implements IUpdateParticipantRoleRequest {
    newRole!: AcsRoomRole;

    constructor(data?: IUpdateParticipantRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newRole = _data["newRole"];
        }
    }

    static fromJS(data: any): UpdateParticipantRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParticipantRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newRole"] = this.newRole;
        return data;
    }
}

export interface IUpdateParticipantRoleRequest {
    newRole: AcsRoomRole;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
